import { message } from "antd";
import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext<any>(null!);

function getInitialUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

function getInitialAuth() {
  const auth = localStorage.getItem("auth");
  return auth ? JSON.parse(auth) : null;
}

function getInitialToken() {
  const token = localStorage.getItem("token");
  return token ? token : null;
}

const AuthProvider = ({ children, location }: any) => {
  const [user, setUser] = useState<any>(getInitialUser);
  const [token, setToken] = useState<any>(getInitialToken);
  const [auth, setAuth] = useState<boolean>(getInitialAuth);

  const navigate = useNavigate();

  const signin = (payload: any) => {
    const { user, auth, token } = payload;
    if (token) {
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("auth", JSON.stringify(auth));
      localStorage.setItem("token", token);
      setToken(token);
      setUser(user);
      setAuth(auth);
    }
    navigate("/calendar");
  };

  const signout = () => {
    localStorage.setItem("user", "");
    localStorage.setItem("token", "");
    setUser(null);
    setToken(null);
    navigate("/");
    message.success("Logged out successfully");
  };

    const updateUser = (user: any) => {
      localStorage.setItem("user", JSON.stringify(user));
      setUser(user);
    };

    const updateAuth = (auth: any) => {
      localStorage.setItem("auth", JSON.stringify(auth));
      setAuth(auth);
    };

    const handleFetchAuth = async () => {
      if (token) {
        setToken(token);
      }
    };

    let value = {
      user,
      setUser,
      updateUser,
      token,
      setToken,
      auth,
      setAuth,
      updateAuth,
      signin,
      signout,
    };

  useEffect(() => {
    handleFetchAuth();
  }, []);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export { AuthContext, AuthProvider };
